import { IConfig } from '@cian/config/shared';
import { IMultiPostingPlatformsByRegion } from '../../../../../../shared/redux/types/multiPosting/types';

export const getPlatforms = (config: IConfig, experimentGroup: string, regionId: number) => {
  const multiPostingPlatforms =
    config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};

  if (!regionId || !multiPostingPlatforms[regionId]) {
    return [];
  }

  const regionData = multiPostingPlatforms[regionId];
  if (experimentGroup === 'B') {
    return regionData.paid.concat(regionData.free);
  } else if (experimentGroup === 'C') {
    return regionData.free;
  }

  return [];
};
